import { GET_USER_PROFILE } from 'api/wenjetso/graphql/queries'
import { UPDATE_USER_PROFILE, UPDATE_USER_PASSWORD } from 'api/wenjetso/graphql/mutations'
// eslint-disable-next-line import/no-cycle
import { authStoreId } from 'stores'

/**
 * User Store
 * 
 * @typedef {object} UserStore
 * @property {UserState} state - User state
 * @property {UserAction} actions - User actions
 * */


/**
 * User State
 * 
 * @typedef {object} UserState
 * @property {object} profile - User profile
 */
const initState = {
  profile: null,
}

const actionTypes = {
  setUserProfile: 'setUserProfile',
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.setUserProfile: {
      return {
        ...state,
        profile: action.profile,
      }
    }
    default:
      return state
  }
}

/**
 * User Getters
 * 
 * @typedef {object} UserGetter
 * @property {Function} getUserProfile - Get user profile
 */

/** @type {import('libs/store').StoreGettersInterface} */
// eslint-disable-next-line func-names
const getters = function ({state}) {
  this.getUserProfile = () => state.profile
  return this
}

/**
 * User Actions
 * 
 * @typedef {object} Userction
 * @property {Function} fetchProfile - Fetch user profile
 */

 /** @type {import('libs/store').StoreActionsInterface} */
// eslint-disable-next-line func-names
const actions = function ({ dispatch, plugins, useStore }) {
  const { requestGraphQL, requestGraphQLFiles } = plugins
  this.setUserProfile = (profile) => {
    dispatch({type : actionTypes.setUserProfile, profile})
  }
  this.fetchUser = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const authStore = useStore(authStoreId)
    const response = await requestGraphQL(GET_USER_PROFILE, {}, authStore.getters.getAccessToken())
    if (!response.error) {
      const payload = response.get_user_profile
      this.setUserProfile(payload)
    }
    return response
  }
  this.updateProfile = async (fullName) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const authStore = useStore(authStoreId)
    const response = await requestGraphQL(UPDATE_USER_PROFILE, {
      input: {
        full_name: fullName,
      }
    }, authStore.getters.getAccessToken())
    if (!response.error) {
      const payload = response.update_user_profile
      this.setUserProfile(payload)
    }
    return response
  }
  this.uploadProfileImage = async (file) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const authStore = useStore(authStoreId)
    const response = await requestGraphQLFiles(UPDATE_USER_PROFILE, null, {
      fieldName: 'profileFile',
      file
    }, authStore.getters.getAccessToken(), {
      format: 'formData'
    })
    if (!response.error) {
      const payload = response.update_user_profile
      this.setUserProfile(payload)
    }
    return response
  }
  this.updateUserPassword = async ({ oldPassword, newPassword }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const authStore = useStore(authStoreId)
    const response = await requestGraphQL(UPDATE_USER_PASSWORD, {
      input: {
        old_password: oldPassword,
        new_password: newPassword,
      }
    }, authStore.getters.getAccessToken())
    return response
  }
  return this
}

 /**
  * @type {import('libs/store').StoreInterface}
  */
export const userStore = {
  initState,
  reducer,
  getters,
  actions,
}